@if (!online) {
    <div class="connectivity-banner connectivity-banner--offline">
        Je hebt op dit moment geen internetverbinding.
    </div>
} @else if (quality === 'poor') {
    <div class="connectivity-banner connectivity-banner--poor">
        Je internetverbinding is momenteel erg traag.
    </div>
}
